import PropTypes from "prop-types";
import React from "react";
import { fetchPortfolioCollection } from "../../utils/apis";
import { Flex, Text, Modal, useMantineTheme } from "@mantine/core";
import CustomButton from "../mantineCustomComponents/CustomButton";
const PortfolioCollectionWindow = ({
  collectionID,
  portfolio,
  openedModalPortfolio,
  onOpenedModalPortfolio,
  setPortfolioChange,
}) => {
  // Mantine theme instance to apply custom styles and theming throughout the component
  const theme = useMantineTheme();

  // Put Portfolio enable/disable
  const handleClickPortfolioCollection = async () => {
    fetchPortfolioCollection(
      collectionID,
      portfolio,
      onOpenedModalPortfolio,
      setPortfolioChange,
    );
  };

  return (
    <Modal
      opened={openedModalPortfolio}
      onClose={() => onOpenedModalPortfolio(false)}
      centered
      size="22rem"
      overlayProps={{
        backgroundOpacity: 0.55,
        blur: 3,
      }}
    >
      <Text
        classNames={{
          root: portfolio
            ? "modal-text-portfolio-enable"
            : "modal-text-portfolio-disable",
        }}
      >
        {portfolio
          ? "Enable this collection to be used for investment performance dashboards. This lets us know to generate dashboards based on the portfolio data it contains"
          : "Are you sure you want to stop using this collection for investment performance dashboards? This will remove any associated dashboards."}
      </Text>

      <Text
        styles={() => ({
          root: {
            fontSize: "1.5em",
            textAlign: "center",
            marginTop: "1em",
            marginBottom: "1em",
          },
        })}
      >
        Proceed?
      </Text>

      <Flex
        justify={theme.flex.justify.center}
        gap={theme.flex.gap.large}
        mb={theme.margin.xl}
      >
        <CustomButton
          text="Yes"
          componentClasses="buttonBlack modal-button-submit"
          onClick={() => handleClickPortfolioCollection()}
        ></CustomButton>
        <CustomButton
          text="No"
          componentClasses="buttonWhite"
          onClick={() => onOpenedModalPortfolio(false)}
        ></CustomButton>
      </Flex>
    </Modal>
  );
};

PortfolioCollectionWindow.propTypes = {
  collectionID: PropTypes.string,
  portfolio: PropTypes.string.isRequired,
  setPortfolioChange: PropTypes.func.isRequired,
  openedModalPortfolio: PropTypes.bool.isRequired,
  onOpenedModalPortfolio: PropTypes.func.isRequired,
};
export default PortfolioCollectionWindow;
